module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "head-section"
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('div', [_c('i', {
    staticClass: "material-icons white--text",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('suggestions')
      }
    }
  }, [_vm._v("arrow_back_ios")])]), _vm._v(" "), _c('div', {
    staticClass: "done",
    on: {
      "click": function($event) {
        return _vm.fillTravelInfo()
      }
    }
  }, [_vm._v("\n        Done\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "head"
  }, [_c('div', [_vm._v(_vm._s(_vm.headTag))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.subheadTag))])])]), _vm._v(" "), _c('div', {
    staticClass: "input-section"
  }, [_c('div', {
    staticClass: "input-header"
  }, [_vm._v("\n      Your input\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "selected-suggestions"
  }, [_c('div', {
    staticClass: "default-text text-xs-left"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.travel),
      expression: "travel"
    }],
    attrs: {
      "placeholder": "Tap here to start writing travel tips."
    },
    domProps: {
      "value": (_vm.travel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.travel = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "suggestion-section white--text"
  }, [_c('div', {
    staticClass: "suggestion-ques"
  }, [_vm._v("\n      Example questions to answer as travel tips.\n      "), _c('br'), _vm._v("\n      What is this spot about?\n      "), _c('br'), _vm._v("\n      \u2028Why should others visit this place?\n      "), _c('br'), _vm._v("\n      Is it a crowded or touristic location?\n      "), _c('br'), _vm._v("\n      What is the best daytime and season to visit?\u2028\n      "), _c('br'), _vm._v("\n      How can one get to the exact photo spot?\n      "), _c('br'), _vm._v("\n      Is parking available?\u2028\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef69b936","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploadImage/travel-info.vue
// module id = 850
// module chunks = 6